// Maps common technical errors to copy a normal person would understand.
// Falls back to the raw message (truncated) so we don't hide useful info.
export function friendlyError(err: unknown): string {
  if (err == null) return "Something went wrong.";
  // Supabase / PostgrestError objects aren't Error instances; they're plain
  // objects with .message / .hint / .details / .code. Stringifying them
  // gives "[object Object]" — pull the message manually so we surface
  // something useful.
  let msg: string;
  if (err instanceof Error) {
    msg = err.message;
  } else if (typeof err === "string") {
    msg = err;
  } else if (typeof err === "object") {
    const o = err as { message?: unknown; hint?: unknown; details?: unknown; error?: unknown; code?: unknown };
    msg =
      (typeof o.message === "string" && o.message) ||
      (typeof o.error === "string" && o.error) ||
      (typeof o.details === "string" && o.details) ||
      (typeof o.hint === "string" && o.hint) ||
      (typeof o.code === "string" && `Error ${o.code}`) ||
      JSON.stringify(err);
  } else {
    msg = String(err);
  }
  const m = msg.toLowerCase();

  if (m.includes("failed to fetch") || m.includes("network") || m.includes("err_internet")) {
    return "Network problem. Check your connection and try again.";
  }
  if (m.includes("timeout") || m.includes("timed out")) {
    return "Request timed out. Try again.";
  }
  if (m.includes("jwt") || m.includes("unauthorized") || m.includes("401")) {
    return "Your session expired. Sign out and back in.";
  }
  if (m.includes("permission denied") || m.includes("forbidden") || m.includes("403")) {
    return "You don't have permission to do that.";
  }
  if (m.includes("duplicate key") || m.includes("unique constraint")) {
    return "Already exists.";
  }
  if (m.includes("postgrest") || m.includes("pgrst")) {
    return "Database error. Try again in a moment.";
  }
  if (m.includes("open food facts") || m.includes("openfoodfacts")) {
    return "Food database is having issues. Try again in a moment, or use Photo instead.";
  }
  if (m.includes("gemini") || m.includes("429") || m.includes("quota") || m.includes("rate limit")) {
    return "AI service is busy. Try again in a moment.";
  }
  if (m.includes("product not found")) {
    return msg; // already user-friendly from openfoodfacts.ts
  }

  // Default: keep the raw message but bound it so a 5KB stack doesn't fill the screen.
  return msg.length > 200 ? msg.slice(0, 200) + "…" : msg;
}
